import useAxios, { UseAxiosResult } from 'axios-hooks';
import config from 'config';
import { useKeycloak } from '../../auth/keycloak';
import { useAppContext } from '../../context/appContext';
const url: string = config.api.url;

export function useGetRequest<Result = unknown, ErrorResponse = unknown>({
 path,
 useRouteIssuer = false,
 manual = false
}: {
  path: string;
  headers?: unknown;
  useRouteIssuer?: boolean;
  manual?: boolean;
}): UseAxiosResult<Result, ErrorResponse> {
  const {
    settings: { issuer, routeIssuer },
  } = useAppContext();
  const { keycloak } = useKeycloak();

  keycloak
    .updateToken(5)
    .then(() => {
      localStorage.setItem('kc_token', keycloak.token);
      localStorage.setItem('kc_refreshToken', keycloak.refreshToken);
    })
    .catch(() => keycloak.login());

  return useAxios<Result, ErrorResponse>(
    {
      method: 'GET',
      url: url + '/' + path,
      headers: {
        'X-Prisma-Issuer': (useRouteIssuer)? routeIssuer : issuer?.name,
        Authorization: `Bearer ${keycloak.token}`,
        'backoffice-source': routeIssuer
      },
    },
    {
      useCache: false,
      ssr: false,
      manual
    }
  );
}